<h2 mat-dialog-title>User Settings</h2>
<form [formGroup]="userSettingsGroup">
  <mat-dialog-content>
    <mat-tab-group dynamicHeight color="accent">
      <mat-tab label="General">
        <mat-list>
          <div class="setting-group-title">Results:</div>
          <mat-list-item class="input-height-item">
            <mat-form-field floatLabel="always" hideRequiredMarker="true">
              <mat-label transloco="RESULTS_PER_PAGE"></mat-label>
              <input
                matInput
                type="number"
                formControlName="archiveResultsPerPage"
              />
              <mat-hint>{{ 'BETWEEN_25_AND_200' | transloco }}</mat-hint>
            </mat-form-field>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="searchCountEnabled">
              {{ 'SHOW_ARCHIVE_SEARCH_RESULT_COUNTS' | transloco }}
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="sortResultsArchivesByResultsCount">
              {{ 'MULTI_ARCHIVE_COUNT_SORT' | transloco }}
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="hideArchivesWithNoResults">
              {{ 'MULTI_ARCHIVE_HIDE_EMPTY' | transloco }}
            </mat-checkbox>
          </mat-list-item>
          @if ((allowGuestSquare9Viewer$ | async) || !isGuest) {
            <mat-list-item>
              <mat-checkbox formControlName="doubleClickOpen">
                {{ 'DOUBLE_CLICK_TO_OPEN_DOCUMENTS' | transloco }}
              </mat-checkbox>
            </mat-list-item>
          }
          <mat-list-item>
            @if ((allowGuestSquare9Viewer$ | async) || !isGuest) {
              <mat-checkbox
                formControlName="usePreviousSearchCriteriaInRelatedSearch"
              >
                {{ 'USE_PREVIOUS_SEARCH_RELATED' | transloco }}
              </mat-checkbox>
            }
          </mat-list-item>
          <mat-list-item>
            @if ((allowGuestSquare9Viewer$ | async) || !isGuest) {
              <mat-checkbox formControlName="alwaysOpenNewTab">
                {{ 'GRID_OPEN_DOCUMENT_IN_NEW_TAB' | transloco }}
              </mat-checkbox>
            }
          </mat-list-item>
          <mat-list-item>
            @if ((allowGuestSquare9Viewer$ | async) || !isGuest) {
              <mat-checkbox
                formControlName="refreshResultsWhenClosingDocumentTabs"
              >
                {{
                  'REFRESH_RESULTS_WHEN_CLOSING_DOCUMENTS_OPENED_IN_TAB'
                    | transloco
                }}
              </mat-checkbox>
            }
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="useBrowserLocaleToParseData">
              <span transloco="USE_BROWSER_LOCALE_TO_DISPLAY_DATA"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="showTableFieldColumnsInGrid">
              <span transloco="SHOW_TABLE_FIELD_COLUMNS_IN_THE_GRID"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="rightAlignNumericValuesInGrid">
              <span transloco="RIGHT_ALIGN_NUMERIC_VALUES_IN_GRID"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="showContentSearchTermsInPdfPreview">
              <span transloco="SHOW_CONTENTSEARCH_HITS_IN_PDF_PREVIEW"></span>
            </mat-checkbox>
          </mat-list-item>
          <div class="setting-group-title">Archive History:</div>
          <mat-list-item class="input-height-item">
            <mat-form-field floatLabel="always" hideRequiredMarker="true">
              <mat-label transloco="RESULTS_PER_PAGE"></mat-label>
              <input
                matInput
                type="number"
                formControlName="archiveHistoryResultsPerPage"
              />
              <mat-hint>{{ 'BETWEEN_25_AND_200' | transloco }}</mat-hint>
            </mat-form-field>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="showDomainInHistoryResults">{{
              'SHOW_DOMAIN_IN_HISTORY' | transloco
            }}</mat-checkbox>
          </mat-list-item>
        </mat-list>
      </mat-tab>
      <mat-tab label="Appearance">
        <mat-list>
          <div class="setting-group-title">{{ 'THEME' | transloco }}:</div>
          <mat-form-field class="list-adjusted-form-control">
            <mat-label>Color Theme</mat-label>
            <mat-select formControlName="themeMode">
              <mat-option [value]="themeModes.light">
                {{ 'LIGHT' | transloco }}
              </mat-option>
              <mat-option [value]="themeModes.dark">
                {{ 'DARK' | transloco }}
              </mat-option>
              <mat-option [value]="themeModes.system">
                {{ 'FOLLOW_SYSTEM' | transloco }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-list-item>
            <mat-checkbox formControlName="useCompactMode">
              {{ 'USE_COMPACT_MODE' | transloco }}
            </mat-checkbox>
          </mat-list-item>
          @if (!isGuest && (taskSearchesDisabled$ | async) === false) {
            <div class="setting-group-title">GlobalAction Tasks:</div>
            <mat-list-item>
              <mat-checkbox
                (change)="onShowGlobalActionTasksChange($event)"
                formControlName="showGlobalActionTasks"
              >
                {{ 'ENABLED' | transloco }}
              </mat-checkbox>
            </mat-list-item>
          }
        </mat-list>
        @if (
          !isGuest &&
          (taskSearchesDisabled$ | async) === false &&
          userSettingsGroup.value.showGlobalActionTasks
        ) {
          <div>
            <mat-accordion>
              <mat-expansion-panel class="darkened-background">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{
                    'AVAILABLE_TASKS' | transloco
                  }}</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-selection-list formControlName="enabledTasksList">
                  @for (task of taskSearches$ | async; track task) {
                    <mat-list-option [value]="task.id">
                      {{ task.title }}
                    </mat-list-option>
                  }
                </mat-selection-list>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
        <mat-list>
          <div class="setting-group-title">
            {{ 'NOTIFICATIONS' | transloco }}
          </div>
          <mat-form-field class="list-adjusted-form-control">
            <mat-label>{{ 'NOTIFICATION_POSITION' | transloco }}</mat-label>
            <mat-select formControlName="notificationPosition">
              <mat-option value="toast-top-center">
                {{ 'TOP_CENTER' | transloco }}
              </mat-option>
              <mat-option value="toast-top-left">
                {{ 'TOP_LEFT' | transloco }}
              </mat-option>
              <mat-option value="toast-top-right">
                {{ 'TOP_RIGHT' | transloco }}
              </mat-option>
              <mat-option value="toast-bottom-center">
                {{ 'BOTTOM_CENTER' | transloco }}
              </mat-option>
              <mat-option value="toast-bottom-left">
                {{ 'BOTTOM_LEFT' | transloco }}
              </mat-option>
              <mat-option value="toast-bottom-right">
                {{ 'BOTTOM_RIGHT' | transloco }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-list>
        @if (!isGuest) {
          <mat-list>
            <div class="setting-group-title">Favorite Searches:</div>
            <mat-list-item>
              <mat-checkbox formControlName="showFavoriteSearches">
                <span transloco="ENABLED"></span>
              </mat-checkbox>
            </mat-list-item>
          </mat-list>
        }
        <mat-list>
          <div class="setting-group-title">{{ 'VIEWER' | transloco }}:</div>
          @if (!hideInternalViewerOptions()) {
            <mat-list-item>
              <mat-checkbox formControlName="viewerUseInternal"
                ><span transloco="USE_INTERNAL_DOCUMENT_VIEWER"></span>
              </mat-checkbox>
            </mat-list-item>
          }
          @if (internalImportsSupported && !hideInternalViewerOptions()) {
            <mat-list-item>
              <mat-checkbox formControlName="viewerUseInternalForImport"
                ><span
                  transloco="USE_INTERNAL_DOCUMENT_VIEWER_FOR_IMPORTS"
                ></span>
              </mat-checkbox>
            </mat-list-item>
          }
          <mat-list-item>
            <mat-checkbox
              formControlName="internalViewerClearCacheOnReturnToSearch"
            >
              <span
                transloco="INTERNAL_VIEWER_CLEAR_CACHE_SEARCH_ON_RETURN_TO_RESULTS"
              ></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="viewerOpenTableFieldsInSidebar">
              <span transloco="OPEN_TABLE_FIELDS_IN_SIDEBAR"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox
              formControlName="autoSave"
              (change)="onAutoSaveCheckChange($event)"
              ><span
                transloco="AUTOMATICALLY_SAVE_DOCUMENT_CHANGES_SETTING"
              ></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="autoSaveOnVersioningArchives"
              ><span
                transloco="AUTOMATICALLY_SAVE_DOCUMENT_CHANGES_SETTING_ON_VERSIONING_ARCHIVES"
              ></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox
              formControlName="viewerAutoSave"
              (change)="onLegacyAutoSaveCheckChange($event)"
              ><span
                transloco="AUTOMATICALLY_SAVE_DOCUMENT_CHANGES_ON_NAVIGATION_SETTING"
              ></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="indexerReloadAfterSave"
              ><span transloco="RELOAD_FIELDS_AFTER_SAVE"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="persistArchiveImportData"
              ><span transloco="PERSIST_ARCHIVE_IMPORT_DATA_SETTING"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="autoSizeTextAreasToContentOnFocus">
              <span
                transloco="AUTOMATICALLY_RESIZE_TEXT_AREAS_TO_FIT_CONTENT_ON_FOCUS"
              ></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox
              formControlName="autoOpenFirstTableFieldOnIndexerLoad"
            >
              <span
                transloco="AUTOMATICALLY_LOAD_THE_FIRST_TABLE_FIELD_ON_LOAD"
              ></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label>{{ 'DEFAULT_DOCUMENT_ZOOM' | transloco }}</mat-label>
              <mat-select formControlName="defaultPageZoom">
                @for (zoom of zoomSettings; track zoom) {
                  <mat-option [value]="zoom.value">
                    {{ zoom.label | transloco }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          </mat-list-item>
        </mat-list>
        <mat-list>
          <div class="setting-group-title">Data XChange:</div>
          <mat-list-item>
            <mat-checkbox formControlName="dxcSearchSystemFields"
              ><span transloco="DXC_SEARCH_SYSTEM_FIELDS"></span>
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="dxcAppendToMultivalue"
              ><span transloco="DXC_APPEND_MULTIVALUES"></span>
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
        <mat-list>
          <div class="setting-group-title">{{ 'NAVIGATION' | transloco }}:</div>
          <mat-list-item>
            <mat-checkbox formControlName="showVersionsArchive"
              ><span transloco="SHOW_VERSIONS_ARCHIVE"></span>
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
        <mat-list>
          <div class="setting-group-title">{{ 'INDEXING' | transloco }}:</div>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label
                transloco="DROPDOWN_TO_TYPEAHEAD_THRESHOLD"
              ></mat-label>
              <input
                matInput
                placeholder="1000"
                formControlName="dropdownToTypeaheadConversionThreshold"
                type="number"
                min="1"
                step="1"
              />
              <mat-hint align="start">{{
                'DROPDOWN_TO_TYPEAHEAD_THRESHOLD_HINT' | transloco
              }}</mat-hint>
              @if (
                userSettingsGroup.controls.dropdownToTypeaheadConversionThreshold.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              } @else if (
                userSettingsGroup.controls.dropdownToTypeaheadConversionThreshold.hasError(
                  'pattern'
                )
              ) {
                <mat-error>{{
                  'INVALID_DROPDOWN_THRESHOLD' | transloco
                }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="showTableCellEditorButtons">
              {{ 'SHOW_TABLE_CELL_EDITOR_BUTTONS' | transloco }}
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
      </mat-tab>
      <mat-tab [label]="'ANNOTATIONS' | transloco">
        <mat-list>
          <div class="setting-group-title">{{ 'NOTES' | transloco }}:</div>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="FILL_COLOR"></mat-label>
              <input
                matInput
                placeholder="#ffffff"
                formControlName="annotationNoteDefaultFillColor"
              />
              <ngx-colors
                class="color-picker-suffix"
                ngx-colors-trigger
                formControlName="annotationNoteDefaultFillColor"
                format="hex"
                matSuffix
              ></ngx-colors>
              @if (
                userSettingsGroup.controls.annotationNoteDefaultFillColor.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              } @else if (
                userSettingsGroup.controls.annotationNoteDefaultFillColor.hasError(
                  'invalidColor'
                )
              ) {
                <mat-error>{{ 'COLOR_NOT_VALID' | transloco }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="FONT"></mat-label>
              <mat-select formControlName="annotationNoteDefaultFontName">
                @for (font of availableFonts; track font) {
                  <mat-option [value]="font">
                    {{ font }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="FONT_SIZE"></mat-label>
              <input
                matInput
                placeholder="70"
                min="0"
                type="number"
                formControlName="annotationNoteDefaultFontSize"
              />
              @if (
                userSettingsGroup.controls.annotationNoteDefaultFontSize.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="OUTLINE_OPACITY"></mat-label>
              <input
                matInput
                placeholder="1"
                step="0.05"
                min="0"
                max="1"
                type="number"
                formControlName="annotationNoteDefaultOutlineOpacity"
              />
              @if (
                userSettingsGroup.controls.annotationNoteDefaultOutlineOpacity.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
        </mat-list>
        <mat-list>
          <div class="setting-group-title">{{ 'STAMPS' | transloco }}:</div>
          <mat-list-item class="chip-input-height-item">
            <mat-form-field>
              <mat-label transloco="CUSTOM_STAMPS"></mat-label>
              <mat-chip-grid
                #reactiveChipGrid
                aria-label="Enter reactive form keywords"
                formControlName="customStamps"
              >
                @for (stamp of customStamps(); track stamp) {
                  <mat-chip-row (removed)="removeCustomStamp(stamp)">
                    {{ stamp }}
                    <button
                      matChipRemove
                      [attr.aria-label]="'remove reactive form' + stamp"
                    >
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
              </mat-chip-grid>
              <input
                #customStampsChipInput="matChipInput"
                placeholder="New stamp..."
                [matChipInputFor]="reactiveChipGrid"
                (matChipInputTokenEnd)="addCustomStamp($event)"
              />
              <button
                mat-icon-button
                matSuffix
                matTooltip="{{ 'ADD_CUSTOM_STAMP_TOOLTIP' | transloco }}"
                (click)="addCustomStampButtonClicked(customStampsChipInput)"
              >
                <mat-icon>add</mat-icon>
              </button>
            </mat-form-field>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="COLOR"></mat-label>
              <input
                matInput
                placeholder="#f08080"
                formControlName="annotationStampDefaultColor"
              />
              <ngx-colors
                class="color-picker-suffix"
                ngx-colors-trigger
                formControlName="annotationStampDefaultColor"
                format="hex"
                matSuffix
              ></ngx-colors>
              @if (
                userSettingsGroup.controls.annotationStampDefaultColor.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              } @else if (
                userSettingsGroup.controls.annotationStampDefaultColor.hasError(
                  'invalidColor'
                )
              ) {
                <mat-error>{{ 'COLOR_NOT_VALID' | transloco }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="OUTLINE_OPACITY"></mat-label>
              <input
                matInput
                placeholder="1"
                step="0.05"
                min="0"
                max="1"
                type="number"
                formControlName="annotationStampDefaultOpacity"
              />
              @if (
                userSettingsGroup.controls.annotationStampDefaultOpacity.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
          <mat-list-item class="input-height-item">
            <mat-form-field>
              <mat-label transloco="THICKNESS"></mat-label>
              <input
                matInput
                placeholder="15"
                step="1"
                min="1"
                type="number"
                formControlName="annotationStampDefaultThickness"
              />
              @if (
                userSettingsGroup.controls.annotationStampDefaultThickness.hasError(
                  'required'
                )
              ) {
                <mat-error>{{ 'REQUIRED' | transloco }}</mat-error>
              }
            </mat-form-field>
          </mat-list-item>
        </mat-list>
      </mat-tab>
      <mat-tab [label]="'KEYFREE' | transloco">
        <mat-list>
          <div class="setting-group-title">
            {{ 'KEYFREE_TYPE' | transloco }}:
          </div>
          <mat-list-item>
            <mat-checkbox formControlName="keyfreeUseOcr">
              {{ 'USE_OCR' | transloco }}
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="keyfreeAutoOcr">
              {{ 'USE_AUTO_OCR' | transloco }}
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox formControlName="keyfreeAutoStartOnDocumentLoad">
              {{
                'AUTOMATICALLY_ENABLE_KEYFREE_WHEN_A_DOCUMENT_LOADS' | transloco
              }}
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
      </mat-tab>
      <mat-tab [label]="'LANGUAGE' | transloco">
        <mat-selection-list
          formControlName="currentLanguage"
          [multiple]="false"
        >
          @for (language of languages$ | async; track language) {
            <mat-list-option [value]="language">
              {{ language }}
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-tab>
      @if (showUserTab) {
        <mat-tab [label]="'USER' | transloco" #userTab>
          <mat-list>
            <form [formGroup]="userPasswordFormGroup">
              <div class="setting-group-title">
                {{ 'CHANGE_PASSWORD' | transloco }}:
              </div>
              <mat-list-item class="input-height-item">
                <mat-form-field hideRequiredMarker="true">
                  <mat-label transloco="CURRENT_PASSWORD"></mat-label>
                  <input
                    matInput
                    type="password"
                    formControlName="currentPassword"
                  />
                  @if (
                    userPasswordFormGroup.controls.currentPassword.hasError(
                      'required'
                    )
                  ) {
                    <mat-error>{{
                      'PASSWORD_IS_REQUIRED' | transloco
                    }}</mat-error>
                  }
                </mat-form-field>
              </mat-list-item>
              <mat-list-item class="input-height-item">
                <mat-form-field>
                  <mat-label transloco="NEW_PASSWORD"></mat-label>
                  <input
                    matInput
                    #password
                    formControlName="newPassword"
                    type="password"
                  />
                </mat-form-field>
              </mat-list-item>
              <mat-list-item class="password-height-item">
                <mat-password-strength
                  matLine
                  #passwordComponent
                  [password]="password.value"
                  [enableLengthRule]="!customPasswordRegexProvided"
                  [enableLowerCaseLetterRule]="!customPasswordRegexProvided"
                  [enableUpperCaseLetterRule]="!customPasswordRegexProvided"
                  [enableDigitRule]="!customPasswordRegexProvided"
                  [enableSpecialCharRule]="!customPasswordRegexProvided"
                  [max]="20"
                >
                </mat-password-strength>
                <mat-password-strength-info
                  #passwordStrengthInfo
                  matLine
                  [passwordComponent]="passwordComponent"
                >
                </mat-password-strength-info>
              </mat-list-item>
              <mat-list-item class="input-height-item">
                <mat-form-field>
                  <mat-label transloco="CONFIRM_PASSWORD"></mat-label>
                  <input
                    matInput
                    [formControl]="
                      passwordComponent.passwordConfirmationFormControl
                    "
                    type="password"
                  />
                  @if (
                    passwordComponent.passwordConfirmationFormControl.hasError(
                      'notConfirmed'
                    )
                  ) {
                    <mat-error>{{
                      'PASSWORD_AND_CONFIRM_DO_NOT_MATCH' | transloco
                    }}</mat-error>
                  }
                </mat-form-field>
              </mat-list-item>
            </form>
          </mat-list>
          @if (isTenantAdmin()) {
            <mat-card class="warning-card">
              <mat-card-header>
                <mat-card-title class="warning-title"
                  ><mat-icon color="#ff6700" class="warning-icon"
                    >warning</mat-icon
                  >{{ 'WARNING' | transloco }}</mat-card-title
                >
              </mat-card-header>
              <mat-card-content>
                <span>
                  <p>{{ 'TENANTADMIN_WARNING' | transloco }}</p>
                  <div style="text-align: right">
                    <button mat-button (click)="openTenantLink()">
                      <label>{{ 'LEARN_MORE' | transloco }}</label>
                    </button>
                  </div>
                </span>
              </mat-card-content>
            </mat-card>
          }
        </mat-tab>
      }
    </mat-tab-group>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>
      <span transloco="CANCEL"></span>
    </button>
    <button mat-button (click)="onReset()">
      <span transloco="RESET"></span>
    </button>
    <span class="spacer"></span>
    @if (userTabIsActive) {
      <button
        mat-button
        (click)="onUpdatePassword()"
        [disabled]="disableUserProfileUpdate"
      >
        <span transloco="UPDATE"></span>
      </button>
    }
    @if (!userTabIsActive) {
      <button
        [disabled]="userSettingsGroup.invalid"
        mat-button
        cdkFocusInitial
        (click)="onSave()"
      >
        <span transloco="SAVE"></span>
      </button>
    }
  </mat-dialog-actions>
</form>
